import { useSyncExternalStore } from 'react';

// Menu lateral aberto só pelo mouse em cima (não empurra o conteúdo; fecha ao sair)
let peek = false;
const subs = new Set();

export const getSidebarPeek = () => peek;
export const setSidebarPeek = (value) => {
  if (peek === value) return;
  peek = value;
  subs.forEach((fn) => fn());
};
export const useSidebarPeek = () =>
  useSyncExternalStore(
    (fn) => {
      subs.add(fn);
      return () => subs.delete(fn);
    },
    () => peek
  );
